import { useTranslation } from "react-i18next";
import { SectionTitle } from "~/components/ui/section-title";

interface AllFeaturesHeroProps {
  headline: string;
  description: string;
}

export function AllFeaturesHero({ headline, description }: AllFeaturesHeroProps) {
  const { t } = useTranslation("products");
  return (
    <section className="fleet:bg-transparent bg-white pt-10 pb-6 md:pt-15 md:pb-10">
      <div className="wrap flex flex-col items-center gap-2 text-center md:gap-3">
        <SectionTitle as="h1" className="text-text-heading max-w-[244px] md:max-w-none">
          {t(headline)}
        </SectionTitle>
        <p className="text-text-body-alt md:text-md max-w-[335px] text-sm leading-5 md:max-w-[640px] md:leading-[1.1]">
          {t(description)}
        </p>
      </div>
    </section>
  );
}
